import {Component} from '@angular/core';
import {TranslocoPipe} from '@jsverse/transloco';

@Component({
  selector: 'app-forbidden',
  imports: [TranslocoPipe],
  template: `
    <p class="flex items-center justify-center w-full h-full font-bold">
      {{ 'FORBIDDEN' | transloco }}
    </p>
  `,
  styles: ``,
})
export class ForbiddenComponent {
}
